import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'
import Link from '../Link'

import styles from './styles'


const decorators = [
  memoized,
]

function PrimaryButton(props) {
  const {
    label,
    route,
    routeParams,
    href,
    onPress,
    target,
    className } = props

  function renderButton() {
    return (
      <Link
        onClick={onPress}
        rel="noopener"
        tabIndex={0}
        role="button"
      >
        {label.toUpperCase()}
      </Link>
    )
  }

  function renderLink() {
    return (
      <Link
        route={route}
        routeParams={routeParams}
        target={target}
      >
        {label.toUpperCase()}
      </Link>
    )
  }

  function renderAnchor() {
    return (
      <Link
        link={href}
        target={target}
        rel="noopener"
      >
        {label.toUpperCase()}
      </Link>
    )
  }

  return (
    <div className={classnames('container', className)}>
      {onPress ? renderButton() : href === null ? renderLink() : renderAnchor()}
      <style jsx>{styles}</style>
    </div>
  )
}

PrimaryButton.propTypes = {
  label: PropTypes.string.isRequired,
  route: PropTypes.string,
  // eslint-disable-next-line
  routeParams: PropTypes.object,
  href: PropTypes.string,
  onPress: PropTypes.func,
  target: PropTypes.string,
  className: PropTypes.string,
}

PrimaryButton.defaultProps = {
  target: '_self',
  href: null,
  onPress: null,
  route: null,
  routeParams: null,
  className: null,
}

PrimaryButton = chainDecorators(decorators, PrimaryButton)

export default PrimaryButton
